import "./reactive-element-BDpydG15-BOs0_4cf.js";
import { query as m } from "./index-JXWggS5z.js";
import { queryAll as v } from "./index-CYExkqVo.js";
const f = ({
  finisher: t,
  descriptor: r
}) => (
  // eslint-disable-next-line consistent-return
  (e, l) => {
    var o;
    if (l !== void 0) {
      const i = e.constructor;
      r !== void 0 && Object.defineProperty(e, l, r(l)), t == null || t(i, l);
    } else {
      const i = (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (o = e.originalKey) != null ? o : e.key
      ), n = r !== void 0 ? {
        kind: "method",
        placement: "prototype",
        key: i,
        descriptor: r(e.key)
      } : { ...e, key: i };
      return t && (n.finisher = function(u) {
        t(u, i);
      }), n;
    }
  }
);
function c(t, r, e = {}, l = !1) {
  var o;
  const i = `slot${r ? `[name=${r}]` : ":not([name])"}`, n = (o = t.renderRoot) == null ? void 0 : o.querySelector(i);
  return n ? l ? n.assignedNodes(e).filter((u) => u.nodeType !== Node.COMMENT_NODE) : n.assignedElements(e) : [];
}
function p(t) {
  return typeof t == "string" ? { version: t } : t.alternateSlot !== void 0 && t.alternateSlot !== null ? { alternateSlot: t.alternateSlot, version: t.version } : { alternateAttribute: t.alternateAttribute, version: t.version };
}
function S(t, r = !1) {
  const { slot: e, selector: l, deprecated: o, flatten: i } = t != null ? t : {};
  let n;
  return o && (n = p(o)), f({
    descriptor: (u) => ({
      get() {
        let a = c(this, e, { flatten: i });
        return a.length === 0 && o && n && n.alternateSlot && (a = c(this, n.alternateSlot, { flatten: i })), l ? a == null ? void 0 : a.filter((s) => {
          var d;
          return r ? ((d = s == null ? void 0 : s.nodeName) == null ? void 0 : d.toLowerCase()) === this.getScopedTagName(l) : s.matches(l);
        }) : a;
      },
      set(a) {
        if (o) {
          const s = e != null ? e : "";
          this.alternateSlots.set(s, n);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function b(t) {
  return function(r, e) {
    return m(t)(r, e);
  };
}
function N(t, r) {
  return f({
    descriptor: (e) => ({
      get() {
        var l;
        return (l = this.querySelector(t)) != null ? l : null;
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
function k(t) {
  return function(r, e) {
    return v(t)(r, e);
  };
}
function q(t, r = !1) {
  const { slot: e, selector: l, deprecated: o, flatten: i } = t != null ? t : {};
  let n;
  return o && (n = p(o)), f({
    descriptor: (u) => ({
      get() {
        let a = c(this, e, { flatten: i }, !0);
        return a.length === 0 && o && n && n.alternateSlot && (a = c(this, n.alternateSlot, { flatten: i }, !0)), a;
      },
      set(a) {
        if (o) {
          const s = e != null ? e : "";
          this.alternateSlots.set(s, n);
        }
      },
      enumerable: !0,
      configurable: !0
    })
  });
}
export {
  k as A,
  q as E,
  b as N,
  S as h,
  N as q
};
